import Vue from 'vue';
import { registerModule } from 'vuex-smart-module';

import { IModule } from '@/types';

import * as Misc from 'src/misc';
import config from './polls.conf.json';

import store from 'src/store';
import PollsStore from './store';

import PollsHomeReminder from './components/PollsHomeReminder.vue';

export function init() {
  Vue.component('polls-home-reminder', PollsHomeReminder);

  registerModule(store, ['polls'], 'polls/', PollsStore);

  Misc.registerModuleConfig(config as IModule);
}
